export default function () {
	// Kontrola pro Checkboxlist nebo Multiselect zda je zaškrtnuta některá z požadovaných hodnot
	// Vychází z pravidla equal, rozdíl je ten, že zde stačí, aby se arg a val měli jakoukoliv společnou hodnotu
	Nette.validators['AppModelUtilsValidatorArrays_containsSome'] = (elem, arg, val) => {
		if (arg === undefined) {
			return null;
		}

		var toString = function (val) {
			if (typeof val === 'number' || typeof val === 'string') {
				return '' + val;
			} else {
				return val === true ? '1' : '';
			}
		};

		val = Array.isArray(val) ? val : [val];
		arg = Array.isArray(arg) ? arg : [arg];
		for (var i1 = 0, len1 = val.length; i1 < len1; i1++) {
			for (var i2 = 0, len2 = arg.length; i2 < len2; i2++) {
				if (toString(val[i1]) === toString(arg[i2])) {
					return true;
				}
			}
		}

		return false;
	};
}
